/**
 * Distance as the reference app prints it: metres below a kilometre, then one
 * decimal of kilometres (`868 m`, `1.8 km`).
 */
export function formatDistance(meters: number): string {
  if (!Number.isFinite(meters) || meters < 0) return ''
  if (meters < 1000) return `${Math.round(meters)} m`
  return `${(meters / 1000).toFixed(1)} km`
}

/**
 * A fare in dong, Vietnamese convention: dot-grouped thousands and a trailing
 * `đ` (`10.000 đ`, `50.000 đ`).
 *
 * Grouped by hand rather than with `Intl.NumberFormat('vi-VN')` because the
 * separator that formatter emits depends on the runtime's ICU data — a Node
 * build without full ICU falls back to `en-US` and silently prints `10,000`.
 *
 * **A fare of 0 is not "free".** `parseFare` in `scripts/extract-timbus-data.mjs`
 * returns 0 for any value it cannot read as digits, so 0 means *unknown* and 2 of
 * the 164 routes in the snapshot carry it. Returning '' keeps a caller from
 * printing `0 đ` at a rider who would then expect a free bus.
 */
export function formatFare(dong: number): string {
  if (!Number.isFinite(dong) || dong <= 0) return ''
  const grouped = String(Math.round(dong)).replace(/\B(?=(\d{3})+$)/g, '.')
  return `${grouped} đ`
}

/**
 * Arrival in whole minutes. Under a minute reads as "now" rather than "0 mins",
 * which looks like missing data.
 */
export function formatEta(minutes?: number): string {
  if (minutes === undefined) return '—'
  if (minutes <= 0) return 'now'
  return `${minutes}`
}
